export default "__VITE_ASSET__a0e6e85d__"